import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentUrlService } from '@shared/services/environment-url';

@Injectable({
  providedIn: 'root'
})
export class RepositoryService {

  constructor(
    private http: HttpClient, 
    private envUrl: EnvironmentUrlService) { }

    private createCompletePath(route: string, envAddress: string) {
      return `${envAddress}/${route}`;
    }
    private generateHeaders() {
      return {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
    }
    // For Get Request
    public getData(route: string) {
      return this.http.get(this.createCompletePath(route, this.envUrl.appUrl));
    }
    // for Post Request
    public createData(route: string, body) {
      return this.http.post(this.createCompletePath(route, this.envUrl.appUrl), body, this.generateHeaders());
    }
    // For update request (if using put)
    public updateData(route: string, body){
      return this.http.put(this.createCompletePath(route, this.envUrl.appUrl), body, this.generateHeaders());
    }
    // For delete request (if using delete)
    public deleteData(route: string){
      return this.http.delete(this.createCompletePath(route, this.envUrl.appUrl));
    }
}
